import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import Lodash from 'lodash';
import Editor from "@monaco-editor/react";

import * as Antd from 'antd';
import * as AntdIcons from '@ant-design/icons';
import * as SYS from './';

const DatasetColumnJoinsSelect = props => {
    const [items, setItems] = useState([]);

    const fetchItems = async () => {
        try {
            let response = await Axios.get(`${process.env.REACT_APP_API_BASE_URI}/api/datasets/columns/joins`);
            return response.data;
        } catch (err) {

        }
    }

    const init = async () => {
        let items = await fetchItems();
        setItems(items);
    }

    useEffect(() => {
        init();
    }, [])

    return (
        <Antd.Select
            mode="tags"
            {...props}
        >
            {items.map((child, idx) => (
                <Antd.Select.Option key={idx} value={child.value}>{child.displayName}</Antd.Select.Option>
            ))}
        </Antd.Select>
    )
}

const DatasetColumnTypes = props => {
    return (
        <Antd.Select
            {...props}
        >
            <Antd.Select.Option value="string">string</Antd.Select.Option>
            <Antd.Select.Option value="date">date</Antd.Select.Option>
            <Antd.Select.Option value="number">number</Antd.Select.Option>
        </Antd.Select>
    )
}

const DatasetFilterTypes = props => {
    return (
        <Antd.Select
            {...props}
        >
            <Antd.Select.Option value="input">Input</Antd.Select.Option>,
            <Antd.Select.Option value="select">Select</Antd.Select.Option>,
            <Antd.Select.Option value="dateRange">DateRange</Antd.Select.Option>,
            <Antd.Select.Option value="datasetSelect">DatasetSelect</Antd.Select.Option>,
            <Antd.Select.Option value="datasetGridSelect">DatasetGridSelect</Antd.Select.Option>,
            <Antd.Select.Option value="datasetTreeSelect">DatasetTreeSelect</Antd.Select.Option>,
        </Antd.Select>
    )
}

const DatasetFilterFieldNameAutoComplete = props => {
    const [options, setOptions] = useState(props.defaultOptions ? props.defaultOptions : []);

    const onSearch = (searchText) => {
        setOptions(Lodash.filter(props.defaultOptions, c => {
            return Lodash.includes(Lodash.lowerCase(c), Lodash.lowerCase(searchText));
        }));
    }

    return (
        <Antd.AutoComplete
            onSearch={onSearch}
            {...props}
        >
            {options.map(option => (
                <Antd.AutoComplete.Option key={option}>{option}</Antd.AutoComplete.Option>
            ))}
        </Antd.AutoComplete>
    )
}

export const DatasetForm = props => {
    const [form] = Antd.Form.useForm();

    const [values, setValues] = useState({});

    const layout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
    };

    const tailLayout = {
        wrapperCol: { span: 18, offset: 6 },
    };

    useEffect(() => {
        setValues(props.initialValues);
    }, [props.initialValues]);

    const renderSQLForm = () => (
        <>
            <Antd.Typography.Title
                level={5}
            >
                Source
            </Antd.Typography.Title>
            <Antd.Form.Item
                noStyle
                name="source"
                label="Source"
                rules={[{ required: true }]}
            >
                <Editor
                    options={{
                        fontSize: 12
                    }}
                    height="30vh"
                    defaultLanguage="sql"
                />
            </Antd.Form.Item>

            <Antd.Tabs defaultActiveKey="1">
                <Antd.Tabs.TabPane tab="Columns" key="1">
                    <Antd.Form.List
                        name="columns"
                    >
                        {(fields, { add, remove }) => (
                            <>
                                {fields.map(field => (
                                    <Antd.Row
                                        key={field.fieldKey}
                                        gutter={[16, 48]}
                                        style={{
                                            marginBottom: 30
                                        }}
                                    >
                                        <Antd.Col
                                            span={8}
                                        >
                                            <Antd.Form.Item
                                                label="Type"
                                                name={[field.name, 'type']}
                                                fieldKey={[field.fieldKey, 'type']}
                                                rules={[{ required: true }]}
                                            >
                                                <DatasetColumnTypes />
                                            </Antd.Form.Item>
                                            <Antd.Form.Item
                                                label="Name"
                                                name={[field.name, 'name']}
                                                fieldKey={[field.fieldKey, 'name']}
                                                rules={[{ required: true }]}
                                            >
                                                <Antd.Input />
                                            </Antd.Form.Item>
                                            <Antd.Form.Item
                                                label="Field"
                                                name={[field.name, 'field']}
                                                fieldKey={[field.fieldKey, 'field']}
                                                rules={[{ required: true }]}
                                                tooltip="Source column name"
                                            >
                                                <Antd.Input />
                                            </Antd.Form.Item>
                                            <Antd.Form.Item
                                                label="Field name"
                                                name={[field.name, 'fieldName']}
                                                fieldKey={[field.fieldKey, 'fieldName']}
                                                rules={[{ required: true }]}
                                                tooltip="Returned property name"
                                            >
                                                <Antd.Input />
                                            </Antd.Form.Item>
                                            <Antd.Form.Item
                                                label="Joins"
                                                name={[field.name, 'joins']}
                                                fieldKey={[field.fieldKey, 'joins']}
                                            >
                                                <DatasetColumnJoinsSelect />
                                            </Antd.Form.Item>
                                            <Antd.Form.Item
                                                label="Roles"
                                                name={[field.name, 'roles']}
                                                fieldKey={[field.fieldKey, 'roles']}
                                                tooltip="Allowed roles (empty for allowed all)"
                                            >
                                                <SYS.UserRoleSelect
                                                    mode="tags"
                                                />
                                            </Antd.Form.Item>
                                        </Antd.Col>
                                        <Antd.Col
                                            span={5}
                                        >
                                            <Antd.Form.Item
                                                label="Enable"
                                                name={[field.name, 'settings', 'datagrid', 'enable']}
                                                fieldKey={[field.fieldKey, 'settings', 'datagrid', 'enable']}
                                                valuePropName="checked"
                                            >
                                                <Antd.Switch />
                                            </Antd.Form.Item>
                                            <Antd.Form.Item
                                                label="Alignment"
                                                name={[field.name, 'settings', 'datagrid', 'alignment']}
                                                fieldKey={[field.fieldKey, 'settings', 'datagrid', 'alignment']}
                                            >
                                                <Antd.Select>
                                                    <Antd.Select.Option value="left">Left</Antd.Select.Option>
                                                    <Antd.Select.Option value="center">Center</Antd.Select.Option>
                                                    <Antd.Select.Option value="right">Right</Antd.Select.Option>
                                                </Antd.Select>
                                            </Antd.Form.Item>
                                            <Antd.Form.Item
                                                label="Fixed"
                                                name={[field.name, 'settings', 'datagrid', 'fixed']}
                                                fieldKey={[field.fieldKey, 'settings', 'datagrid', 'fixed']}
                                            >
                                                <Antd.Select
                                                    allowClear={true}
                                                >
                                                    <Antd.Select.Option value="left">Left</Antd.Select.Option>
                                                    <Antd.Select.Option value="right">Right</Antd.Select.Option>
                                                </Antd.Select>
                                            </Antd.Form.Item>
                                            <Antd.Form.Item
                                                label="Width"
                                                name={[field.name, 'settings', 'datagrid', 'width']}
                                                fieldKey={[field.fieldKey, 'settings', 'datagrid', 'width']}
                                            >
                                                <Antd.InputNumber
                                                    step={10}
                                                />
                                            </Antd.Form.Item>
                                            <Antd.Form.Item
                                                label="Link"
                                                name={[field.name, 'settings', 'datagrid', 'link']}
                                                fieldKey={[field.fieldKey, 'settings', 'datagrid', 'link']}
                                            >
                                                <Antd.Input
                                                    allowClear={true}
                                                />
                                            </Antd.Form.Item>
                                            <Antd.Form.Item
                                                label="Visible"
                                                name={[field.name, 'settings', 'datagrid', 'visible']}
                                                fieldKey={[field.fieldKey, 'settings', 'datagrid', 'visible']}
                                                valuePropName="checked"
                                            >
                                                <Antd.Switch />
                                            </Antd.Form.Item>
                                            <Antd.Form.Item
                                                label="Fulltext"
                                                name={[field.name, 'settings', 'datagrid', 'fulltext']}
                                                fieldKey={[field.fieldKey, 'settings', 'datagrid', 'fulltext']}
                                                valuePropName="checked"
                                            >
                                                <Antd.Switch />
                                            </Antd.Form.Item>
                                            <Antd.Form.Item
                                                label="Sorter"
                                                name={[field.name, 'settings', 'datagrid', 'sorter']}
                                                fieldKey={[field.fieldKey, 'settings', 'datagrid', 'sorter']}
                                                valuePropName="checked"
                                            >
                                                <Antd.Switch />
                                            </Antd.Form.Item>
                                            <Antd.Form.Item
                                                label="Order"
                                                name={[field.name, 'settings', 'datagrid', 'order']}
                                                fieldKey={[field.fieldKey, 'settings', 'datagrid', 'order']}
                                            >
                                                <Antd.InputNumber />
                                            </Antd.Form.Item>
                                        </Antd.Col>
                                        <Antd.Col
                                            span={10}
                                        >
                                            <Antd.Form.Item
                                                labelCol={0}
                                                label="Render"
                                                name={[field.name, 'settings', 'datagrid', 'decodedRender']}
                                                fieldKey={[field.fieldKey, 'settings', 'datagrid', 'decodedRender']}
                                            >
                                                <Editor
                                                    options={{
                                                        fontSize: 12
                                                    }}
                                                    height="35vh"
                                                    defaultLanguage="javascript"
                                                    value=""
                                                />
                                            </Antd.Form.Item>
                                        </Antd.Col>
                                        <Antd.Col
                                            span={1}
                                        >
                                            <AntdIcons.MinusCircleOutlined
                                                onClick={() => remove(field.name)}
                                            />
                                        </Antd.Col>
                                    </Antd.Row>
                                ))}
                                <Antd.Form.Item
                                    wrapperCol={{
                                        span: 18,
                                        offset: 2
                                    }}
                                >
                                    <Antd.Button
                                        block
                                        type="dashed"
                                        onClick={() => add()}
                                        icon={<AntdIcons.PlusOutlined />}>
                                        Add parameter
                                    </Antd.Button>
                                </Antd.Form.Item>
                            </>
                        )}
                    </Antd.Form.List>
                </Antd.Tabs.TabPane>
                <Antd.Tabs.TabPane tab="Conditions" key="2">
                    <Antd.Form.List
                        name="conditions"
                    >
                        {(fields, { add, remove }) => (
                            <>
                                {fields.map(field => (
                                    <Antd.Row
                                        key={field.fieldKey}
                                        gutter={[16, 48]}
                                        style={{
                                            marginBottom: 30
                                        }}
                                    >
                                        <Antd.Col
                                            span={23}
                                        >
                                            <Antd.Form.Item
                                                label="Field name"
                                                name={[field.name, 'fieldName']}
                                                fieldKey={[field.fieldKey, 'fieldName']}
                                                rules={[{ required: true }]}
                                                tooltip="Must not match any the column field name!"
                                            >
                                                <Antd.Input />
                                            </Antd.Form.Item>
                                            <Antd.Form.Item
                                                label="Joins"
                                                name={[field.name, 'joins']}
                                                fieldKey={[field.fieldKey, 'joins']}
                                            >
                                                <DatasetColumnJoinsSelect />
                                            </Antd.Form.Item>
                                            <Antd.Form.Item
                                                label="Definition"
                                                name={[field.name, 'definition']}
                                                fieldKey={[field.fieldKey, 'definition']}
                                            >
                                                <Editor
                                                    options={{
                                                        fontSize: 12
                                                    }}
                                                    height="20vh"
                                                    defaultLanguage="sql"
                                                />
                                            </Antd.Form.Item>
                                        </Antd.Col>
                                        <Antd.Col
                                            span={1}
                                        >
                                            <AntdIcons.MinusCircleOutlined
                                                onClick={() => remove(field.name)}
                                            />
                                        </Antd.Col>
                                    </Antd.Row>
                                ))}
                                <Antd.Form.Item
                                    wrapperCol={{
                                        span: 18,
                                        offset: 2
                                    }}
                                >
                                    <Antd.Button
                                        block
                                        type="dashed"
                                        onClick={() => add()}
                                        icon={<AntdIcons.PlusOutlined />}
                                    >
                                        Add parameter
                                    </Antd.Button>
                                </Antd.Form.Item>
                            </>
                        )}
                    </Antd.Form.List>
                </Antd.Tabs.TabPane>
                <Antd.Tabs.TabPane tab="Filters" key="3">
                    <Antd.Form.List
                        name="filters"
                    >
                        {(fields, { add, remove }) => (
                            <>
                                {fields.map(field => (
                                    <Antd.Row
                                        key={field.fieldKey}
                                        gutter={[16, 48]}
                                        style={{
                                            marginBottom: 30
                                        }}
                                    >
                                        <Antd.Col
                                            span={15}
                                        >
                                            <Antd.Form.Item
                                                label="Type"
                                                name={[field.name, 'type']}
                                                fieldKey={[field.fieldKey, 'type']}
                                                rules={[{ required: true }]}
                                            >
                                                <DatasetFilterTypes />
                                            </Antd.Form.Item>
                                            <Antd.Form.Item
                                                label="Title"
                                                name={[field.name, 'title']}
                                                fieldKey={[field.fieldKey, 'title']}
                                                rules={[{ required: true }]}
                                            >
                                                <Antd.Input />
                                            </Antd.Form.Item>
                                            <Antd.Form.Item
                                                label="Field name"
                                                name={[field.name, 'fieldName']}
                                                fieldKey={[field.fieldKey, 'fieldName']}
                                                rules={[{ required: true }]}
                                                tooltip="Field name from columns or conditions"
                                            >
                                                {/* <Antd.Input /> */}
                                                <DatasetFilterFieldNameAutoComplete
                                                    defaultOptions={values.columns
                                                        ? values.columns.map(c => c.fieldName).concat(values.conditions ? values.conditions.map(co => co.fieldName) : [])
                                                        : values.conditions
                                                            ? values.conditions.map(co => co.fieldName)
                                                            : []
                                                    }
                                                />
                                            </Antd.Form.Item>
                                            <Antd.Form.Item
                                                label="Roles (allow change)"
                                                name={[field.name, 'changeRoles']}
                                                fieldKey={[field.fieldKey, 'changeRoles']}
                                                tooltip="Empty for allowed all"
                                            >
                                                <SYS.UserRoleSelect
                                                    mode="tags"
                                                />
                                            </Antd.Form.Item>

                                            {values
                                                && values.filters
                                                && values.filters[field.fieldKey] !== undefined
                                                && values.filters[field.fieldKey].type
                                                && ['datasetSelect', 'datasetGridSelect', 'datasetTreeSelect'].indexOf(values.filters[field.fieldKey].type) >= 0
                                                ? <>
                                                    <Antd.Form.Item
                                                        label="Connector"
                                                        name={[field.name, 'connector']}
                                                        fieldKey={[field.fieldKey, 'connector']}
                                                    >
                                                        <SYS.ConnectorSelect
                                                            identificator={'code'}
                                                        />
                                                    </Antd.Form.Item>
                                                    <Antd.Form.Item
                                                        label="Dataset"
                                                        name={[field.name, 'dataset']}
                                                        fieldKey={[field.fieldKey, 'dataset']}
                                                    >
                                                        <SYS.DatasetSelect
                                                            identificator={'code'}
                                                        />
                                                    </Antd.Form.Item>
                                                    <Antd.Form.Item
                                                        label="Filters"
                                                        name={[field.name, 'filters']}
                                                        fieldKey={[field.fieldKey, 'filters']}
                                                    >
                                                        <Editor
                                                            options={{
                                                                fontSize: 12
                                                            }}
                                                            height="15vh"
                                                            defaultLanguage="json"
                                                            defaultValue="{}"
                                                        />
                                                    </Antd.Form.Item>
                                                </>
                                                : null}

                                            {values
                                                && values.filters
                                                && values.filters[field.fieldKey] !== undefined
                                                && values.filters[field.fieldKey].type
                                                && ['select'].indexOf(values.filters[field.fieldKey].type) >= 0
                                                ? <Antd.Form.List
                                                    name={[field.name, 'options']}
                                                    initialValue={[]}
                                                >
                                                    {(fields, { add, remove }) => (
                                                        <>
                                                            {fields.map(field => (
                                                                <Antd.Row
                                                                    gutter={[16, 48]}
                                                                >
                                                                    <Antd.Col
                                                                        span={10}
                                                                    >
                                                                        <Antd.Form.Item
                                                                            label="Value"
                                                                            name={[field.name, 'value']}
                                                                            fieldKey={[field.fieldKey, 'value']}
                                                                            rules={[{ required: true }]}
                                                                        >
                                                                            <Antd.Input />
                                                                        </Antd.Form.Item>
                                                                    </Antd.Col>
                                                                    <Antd.Col
                                                                        span={13}
                                                                    >
                                                                        <Antd.Form.Item
                                                                            label="Title"
                                                                            name={[field.name, 'title']}
                                                                            fieldKey={[field.fieldKey, 'title']}
                                                                            rules={[{ required: true }]}
                                                                        >
                                                                            <Antd.Input />
                                                                        </Antd.Form.Item>
                                                                    </Antd.Col>
                                                                    <Antd.Col
                                                                        span={1}
                                                                    >
                                                                        <AntdIcons.MinusCircleOutlined
                                                                            onClick={() => remove(field.name)}
                                                                        />
                                                                    </Antd.Col>
                                                                </Antd.Row>
                                                            ))}
                                                            <Antd.Form.Item
                                                                wrapperCol={{
                                                                    span: 18,
                                                                    offset: 2
                                                                }}
                                                            >
                                                                <Antd.Button
                                                                    block
                                                                    type="dashed"
                                                                    onClick={() => add()}
                                                                    icon={<AntdIcons.PlusOutlined />}
                                                                >
                                                                    Add parameter
                                                                </Antd.Button>
                                                            </Antd.Form.Item>
                                                        </>
                                                    )}
                                                </Antd.Form.List>
                                                : null}

                                        </Antd.Col>
                                        <Antd.Col
                                            span={8}
                                        >
                                            <Antd.Form.Item
                                                label="Tooltip"
                                                name={[field.name, 'tooltip']}
                                                fieldKey={[field.fieldKey, 'tooltip']}
                                            >
                                                <Antd.Input
                                                    allowClear={true}
                                                />
                                            </Antd.Form.Item>
                                            <Antd.Form.Item
                                                label="Help"
                                                name={[field.name, 'help']}
                                                fieldKey={[field.fieldKey, 'help']}
                                            >
                                                <Antd.Input
                                                    allowClear={true}
                                                />
                                            </Antd.Form.Item>
                                            <Antd.Form.Item
                                                label="Order"
                                                name={[field.name, 'order']}
                                                fieldKey={[field.fieldKey, 'order']}
                                            >
                                                <Antd.InputNumber />
                                            </Antd.Form.Item>
                                            <Antd.Form.Item
                                                label="Allow clear"
                                                name={[field.name, 'allowClear']}
                                                fieldKey={[field.fieldKey, 'allowClear']}
                                                valuePropName="checked"
                                            >
                                                <Antd.Switch />
                                            </Antd.Form.Item>
                                            {values
                                                && values.filters
                                                && values.filters[field.fieldKey] !== undefined
                                                && values.filters[field.fieldKey].type
                                                && ['select', 'datasetSelect', 'datasetGridSelect', 'datasetTreeSelect'].indexOf(values.filters[field.fieldKey].type) >= 0
                                                ? <Antd.Form.Item
                                                    label="Multiple"
                                                    name={[field.name, 'multiple']}
                                                    fieldKey={[field.fieldKey, 'multiple']}
                                                    valuePropName="checked"
                                                // initialValue={false}
                                                >
                                                    <Antd.Switch />
                                                </Antd.Form.Item>
                                                : null}
                                        </Antd.Col>
                                        <Antd.Col
                                            span={1}
                                        >
                                            <AntdIcons.MinusCircleOutlined
                                                onClick={() => remove(field.name)}
                                            />
                                        </Antd.Col>
                                    </Antd.Row>
                                ))}
                                <Antd.Form.Item
                                    wrapperCol={{
                                        span: 18,
                                        offset: 2
                                    }}
                                >
                                    <Antd.Button
                                        block
                                        type="dashed"
                                        onClick={() => add()}
                                        icon={<AntdIcons.PlusOutlined />}
                                    >
                                        Add parameter
                                    </Antd.Button>
                                </Antd.Form.Item>
                            </>
                        )}
                    </Antd.Form.List>
                </Antd.Tabs.TabPane>
                <Antd.Tabs.TabPane tab="Default filters" key="4">
                    <Antd.Form.Item
                        label="Default filters"
                        name={['defaultFilters']}
                        fieldKey={['defaultFilters']}
                    >
                        <Editor
                            options={{
                                fontSize: 12
                            }}
                            height="15vh"
                            defaultLanguage="json"
                            defaultValue="{}"
                        />
                    </Antd.Form.Item>
                </Antd.Tabs.TabPane>
                <Antd.Tabs.TabPane tab="Sorting" key="5">
                    <Antd.Form.Item
                        label="Default sort"
                        name={['defaultOrder']}
                        fieldKey={['defaultOrder']}
                    >
                        <Antd.Input />
                    </Antd.Form.Item>
                </Antd.Tabs.TabPane>
            </Antd.Tabs>
        </>
    );

    return (
        <Antd.Form
            {...layout}
            form={form}
            initialValues={props.initialValues}
            onValuesChange={(changedValues, allValues) => {
                if (changedValues.type) {
                    setValues(allValues);
                }
                if (changedValues.filters) {
                    for (let filter of changedValues.filters) {
                        if (filter !== undefined && filter.type) {
                            setValues(allValues);
                        }
                    }
                }
                if (changedValues.columns) {
                    for (let column of changedValues.columns) {
                        if (column !== undefined && column.fieldName !== undefined && column.fieldName) {
                            setValues(allValues);
                        }
                    }
                }
                if (changedValues.conditions) {
                    for (let condition of changedValues.conditions) {
                        if (condition !== undefined && condition.fieldName !== undefined && condition.fieldName) {
                            setValues(allValues);
                        }
                    }
                }
            }}
            onFinish={values => {
                let successValues = Object.assign({}, values);
                for (let columnIdx in successValues.columns) {
                    if (successValues.columns[columnIdx].settings.datagrid.decodedRender !== undefined) {
                        successValues.columns[columnIdx].settings.datagrid.render = btoa(successValues.columns[columnIdx].settings.datagrid.decodedRender);
                    }
                    delete successValues.columns[columnIdx].settings.datagrid.decodedRender;
                }
                if (props.onSuccess) {
                    props.onSuccess(successValues);
                }
            }}
            onFinishFailed={(err) => {
                console.log(err);
            }}
        >
            {props.initialValues && props.initialValues.id
                ? <Antd.Form.Item name="id" label="ID">
                    <Antd.Input disabled={true} />
                </Antd.Form.Item>
                : null}
            <Antd.Form.Item
                name="code"
                label="Code"
                rules={[{ required: true }]}
            >
                <Antd.Input />
            </Antd.Form.Item>
            <Antd.Form.Item
                name="name"
                label="Name"
                rules={[{ required: true }]}
            >
                <Antd.Input />
            </Antd.Form.Item>
            <Antd.Form.Item
                name="type"
                label="Type"
                rules={[{ required: true }]}
            >
                <Antd.Select>
                    <Antd.Select.Option value="sql">SQL</Antd.Select.Option>
                </Antd.Select>
            </Antd.Form.Item>

            {(values && values.type && values.type === 'sql')
                ? renderSQLForm()
                : null}

            <Antd.Form.Item
                {...tailLayout}
                style={{
                    marginTop: 10
                }}
            >
                <Antd.Button
                    type="primary"
                    htmlType="submit"
                >
                    Submit
                </Antd.Button>
            </Antd.Form.Item>
        </Antd.Form >
    );
}